// carriers whose transfer requests are handled entirely by the contracting team, so an

import {
  SUBSTATUSES_WITHOUT_ONBOARDING_SUBMIT,
  TRANSFER_CARRIERS_WITHOUT_ONBOARDING_SUBMIT
} from 'constants/enum';
import { isTransferRequestType } from 'helpers/appointments/appointments';

// carrier names come from Zoho, so compare them case-insensitively
function isTransferCarrierWithoutOnboardingSubmit(carrier) {
  return TRANSFER_CARRIERS_WITHOUT_ONBOARDING_SUBMIT.has(
    (carrier || '').trim().toLowerCase()
  );
}

/**
 * whether the "Onboarding Submitted" action can be offered for an in-progress request.
 * hidden for transfers with carriers the agent never submits to directly, and for any
 * carrier while the agent still owes E&O, FFM or SBE paperwork
 * @param appt - sanitized appointment request (carrier, request_type, substatus)
 */
export default function canSubmitOnboarding(appt) {
  if (SUBSTATUSES_WITHOUT_ONBOARDING_SUBMIT.has(appt?.substatus)) return false;

  if (
    isTransferRequestType(appt) &&
    isTransferCarrierWithoutOnboardingSubmit(appt?.carrier)
  ) {
    return false;
  }

  return true;
}
